import { VehicleService } from "./../../vehicle/models/vehicle.service";
import { VehicleModel } from "./../../vehicle/models/vehicle.model";
import { SharedVehicleGroupService } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { CompanyService } from "./../../company/models/company.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { SharedVehicleGroupModel } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { CompanyModel } from "./../../company/models/company.model";
import { InstanceModel } from "./../../instance/models/instance.model";
import {
  ReportFilterModel,
  DropdownModel
} from "./../models/report-filter.model";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  ApplicationRouteURL,
  WeGoConfig,
  IKeyValueInterface,
  RoleLevel,
  PermissionType
} from "./../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { VehicleOccupancyService } from "./../models/vehicle-occupancy.service";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { ReportFilterService } from "../models/report-filter.service";
import { CustomerService } from "../../customer/models/customer.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { ContractTypeGroupService } from "../../contracttypegroup/models/contracttypegroup.service";

@Component({
  selector: "wego-report-customer-filter",
  template: require('../views/report-filter-customer.component.html'),
  providers: [
    InstanceService,
    CompanyService,
    SharedVehicleGroupService,
    VehicleService,
    OrganizationService,
    ReportFilterService,
    ContractTypeGroupService
  ]
})
export class ReportCustomerFilter implements OnInit {
  @Output("OnSearch") onSearch = new EventEmitter();
  @Output("OnExportPDF") onExportPDF = new EventEmitter();
  @Output("OnExportExcel") onExportExcel = new EventEmitter();
  @Output("ResetValidSearch") resetValidSearch = new EventEmitter();

  @Input("IsValidSearch") isValidSearch: boolean = false;
  @Input("ErrorModel") errorModel: IKeyValueInterface[];
  @Input("ReportName") reportName: string;

  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: ReportFilterModel;
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  contractTypeGroupList: DropdownModel[];
  permissionType: string;
  sharedVehicleGroupList: DropdownModel[];
  vehicleList: DropdownModel[];
  organizationList: DropdownModel[];
  customerList: DropdownModel[];
  apiErrorMsg: string;
  isLoader: boolean;
  roleLevel = RoleLevel;

  constructor(
    private customerService: CustomerService,
    
    private authService: AuthService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private reportFilterService: ReportFilterService,
    private organizationService: OrganizationService,
    private contractTypegroupService: ContractTypeGroupService
  ) {}

  ngOnInit() {
    this.model = new ReportFilterModel();
    this.permissionType = PermissionType.VIEW;
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
    this.InitReportFilter();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public InitReportFilter() {
    // this.GetAllInstanceList();
    this.GetCustomerListDropdown();
  }

  public GetCustomerListDropdown() {
    this.customerService.GetDropdownListCustomer(this.reportName).subscribe(
      (res: any) => {
        this.customerList = res.data;

        if (this.customerList != null && this.customerList.length > 0) {
          if (!this.model.customerHashId && this.customerList.length == 1) {
            this.model.customerHashId = this.customerList[0].keyHash;
          }
          this.OnCustomerChange();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetInstanceListDropdown() {
    this.instanceService
      .GetDropdownInstanceList(this.reportName, this.model.customerHashId)
      .subscribe(
        res => {
          this.instanceList = res.data;
          if (this.instanceList && this.instanceList.length > 0) {
            if (!this.model.instanceHashId && this.instanceList.length == 1) {
              this.model.instanceHashId = this.instanceList[0].keyHash;
            }
            this.OnInstanceChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetAllCompanyList() {
    this.companyService
      .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          if (this.companyList && this.companyList.length > 0) {
            if (
              !this.model.companyMasterHashId &&
              this.companyList.length == 1
            ) {
              this.model.companyMasterHashId = this.companyList[0].keyHash;
            }
            this.OnCompanyChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoader = false;
        }
      );
  }

  // Value should be null in case required all svg
  public GetAllSVGList() {
    this.sharedVehicleGroupService
      .GetDropdownSVGList(
        this.reportName,
        this.model.companyMasterHashId,
        this.model.instanceHashId
      )
      .subscribe(
        res => {
          this.sharedVehicleGroupList = res.data;
          if (
            this.sharedVehicleGroupList &&
            this.sharedVehicleGroupList.length > 0
          ) {
            if (
              !this.model.sharedVehicleGroupHashId &&
              this.sharedVehicleGroupList.length == 1
            ) {
              this.model.sharedVehicleGroupHashId = this.sharedVehicleGroupList[0].keyHash;
            }
            this.OnSVGChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCompanyListByInstance() {
    this.companyService
      .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          if (this.companyList && this.companyList.length > 0) {
            if (
              !this.model.companyMasterHashId &&
              this.companyList.length == 1
            ) {
              this.model.companyMasterHashId = this.companyList[0].keyHash;
            }
            this.OnCompanyChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetSVGBaseOrganizationDropDown() {
    // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
    // let company = sVGHashId != "" ? "" : companyMasterHashId;
    this.organizationService
      .GetSVGBaseOrganizationDropDown(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyMasterHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.organizationList = res.data;
          if (this.organizationList && this.organizationList.length > 0) {
            if (
              !this.model.organizationHashId &&
              this.organizationList.length == 1
            ) {
              this.model.organizationHashId = this.organizationList[0].keyHash;
            }
            this.OnOrganizationChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetVehicleBySVG() {
    // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
    // let company = sVGHashId != "" ? "" : companyMasterHashId;
    this.vehicleService
      .GetDropdownVehicleList(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyMasterHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetContractTypeGroupBySVG() {
    this.contractTypegroupService
      .GetDropdownListCTGBySVG(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyMasterHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.contractTypeGroupList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  // Event
  public OnCustomerChange(): any {
    this.model.instanceHashId = "";
    this.instanceList = [];
    this.model.companyMasterHashId = "";
    this.companyList = [];
    this.model.organizationHashId = "";
    this.organizationList = [];
    this.model.sharedVehicleGroupHashId = "";
    this.sharedVehicleGroupList = [];
    this.model.contractTypeGroupHashId = "";
    this.contractTypeGroupList = [];
    this.model.vehicleHashId = "";
    this.vehicleList = [];
    this.contractTypeGroupList = [];
    this.model.contractTypeGroupHashId = "";
    this.ResetValidSearch();
    if (this.model.customerHashId) {
      this.GetInstanceListDropdown();
    }
  }

  public OnInstanceChange() {
    this.companyList = null;
    this.sharedVehicleGroupList = null;
    this.vehicleList = null;
    this.organizationList = null;
    this.model.companyMasterHashId = "";
    this.model.sharedVehicleGroupHashId = "";
    this.model.vehicleHashId = "";
    this.model.organizationHashId = "";
    this.isLoader = true;
    this.contractTypeGroupList = null;
    this.model.contractTypeGroupHashId = "";
    this.ResetValidSearch();
    if (this.model.instanceHashId) {
      this.GetCompanyListByInstance();
    } else {
      this.companyList = [];
      this.sharedVehicleGroupList = [];
      this.vehicleList = [];
      this.organizationList = [];
      this.model.organizationHashId = "";
      this.model.companyMasterHashId = "";
      this.model.sharedVehicleGroupHashId = "";
      this.model.vehicleHashId = "";
      this.contractTypeGroupList = [];
      this.model.contractTypeGroupHashId = "";
    }
  }

  public OnCompanyChange() {
    this.sharedVehicleGroupList = null;
    this.vehicleList = null;
    this.organizationList = null;
    this.model.sharedVehicleGroupHashId = "";
    this.model.vehicleHashId = "";
    this.model.organizationHashId = "";
    this.isLoader = true;
    this.contractTypeGroupList = null;
    this.model.contractTypeGroupHashId = "";
    this.ResetValidSearch();
    if (this.model.companyMasterHashId) {
      this.GetAllSVGList();
    } else {
      this.sharedVehicleGroupList = [];
      this.vehicleList = [];
      this.organizationList = [];
      this.contractTypeGroupList = [];
      this.model.contractTypeGroupHashId = "";
      this.model.organizationHashId = "";
      this.model.sharedVehicleGroupHashId = "";
      this.model.vehicleHashId = "";
    }
  }

  public OnSVGChange() {
    this.vehicleList = [];
    this.organizationList = [];
    this.contractTypeGroupList = [];
    this.model.vehicleHashId = "";
    this.model.organizationHashId = "";
    this.model.contractTypeGroupHashId = "";
    this.isLoader = true;
    this.ResetValidSearch();
    this.GetSVGBaseOrganizationDropDown();
    this.GetVehicleBySVG();
    this.GetContractTypeGroupBySVG();
  }

  public OnOrganizationChange() {
    this.ResetValidSearch();
  }

  public OnVehicleChange() {
    this.ResetValidSearch();
  }

  public OnCTGChange() {
    this.ResetValidSearch();
  }

  public OnFromDateChange() {
    this.ResetValidSearch();
  }

  public OnToDateChange() {
    this.ResetValidSearch();
  }

  public ResetValidSearch() {
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  // Button Click
  public OnSearch($event: any) {
    this.onSearch.emit({ model: this.model });
  }

  public OnExportPDF($event: any) {
    this.onExportPDF.emit({ model: this.model });
  }

  public OnExportExcel($event: any) {
    this.onExportExcel.emit({ model: this.model });
  }

  public OnSearchChange() {
    this.ResetValidSearch();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/report-filter-customer.component.ts